<template>
  <div>
    <div class="Tranbox_right">
      <div class="charts">
        <div class="chartsall">
          <div class="chartstit">Token Transfers</div>
          <div class="Hombox_sr">
            <div class="hombottn" @click="dianji">
              <div>{{ itemname }}</div>
              <img :src="ImgUrl" />
            </div>
            <div class="headcontent" id="datalist" v-show="valShow">
              <ul v-for="(item, index) in calendarDatas" :key="index">
                <li
                  @click="shuaixuan(item)"
                  :class="index == itemindex ? 'active' : ''"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div id="charts" ref="chart" style="width: 1160px; height: 350px"></div>
      </div>
      <div class="charts">
        <div class="chartsall">
        <div class="chartstit">Holding Account</div>
        <div class="Hombox_sr">
            <div class="hombottn" @click="dianji">
              <div>{{ itemname }}</div>
              <img :src="ImgUrl" />
            </div>
            <div class="headcontent" id="datalist" v-show="valShow">
              <ul v-for="(item, index) in calendarDatas" :key="index">
                <li
                  @click="shuaixuan(item)"
                  :class="index == itemindex ? 'active' : ''"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div
          id="charts"
          ref="charts"
          style="width: 1160px; height: 350px"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../BlockList/Pagination";
import Pagination2 from "../BlockList/Pagination2.vue";
import EmptyState from "../EmptyState/EmptyState.vue";
import { BlockList } from "@/assets/server/api";
import { timestampConvertTime } from "@/utils/utils";
import { goPAGE, formatSeconds, listType, getSubStr } from "@/utils/utils";
const echarts = require("echarts");
export default {
  data() {
    return {
      PaginationIndex: 1,
      total1: null,
      nowLang: "",
      TimeDate: [],
      Page1: "",
      // 开始
      IsShow: false,
      valShow: false,
      itemindex: 0,
      itemname: "1M",
      ImgUrl: require("@/assets/pc/seach/xia.png"),
      calendarDatas: [
        {
          name: "1M",
          value: "",
          id: 0,
        },
        {
          name: "6M",
          value: "",
          id: 1,
        },
        {
          name: "1Y",
          value: "",
          id: 1,
        },
        {
          name: "ALL",
          value: "",
          id: 1,
        },
      ],
      // 结束
    };
  },
  components: {
    Pagination,
    EmptyState,
    Pagination2,
  },
  mounted() {
    this.PaginationIndex = this.getContextData("tiaozhuan1") || 1;
  //  this.blockList();
    this.initCharts();
    this.initChartsa();
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  methods: {
    dianji() {
      if (this.IsShow == false) {
        this.IsShow = true;
        this.valShow = true;
        this.ImgUrl = require("@/assets/pc/seach/xia.png");
      } else if (this.IsShow == true) {
        this.IsShow = false;
        this.valShow = false;
        this.ImgUrl = require("@/assets/pc/seach/shang.png");
      }
    },
    initCharts() {
      var dataaa=[82, 92, 91, 93, 90, 89, 87];
      var indexs="";
      this.lineChart = echarts.init(this.$refs.chart);
      let option = {
       tooltip: {
          trigger: "axis",
          backgroundColor: "#242931", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          formatter: function (params) {
            // console.log(params);
            // console.log(params[0].dataIndex);
             indexs=params[0].dataIndex;
            
            let str =
              '<span style="color:#898B8D;font-size:12px;">' +
              params[0].name +
              "(UTC)" +
              "</span>" +
              "</br>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#00E79A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>Transactions:</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              params[0].value +
              "</span>" +
              "</div>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#D3F85A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>Total TTOS Staked:</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              params[1].value +
              "</span>" +
              "</div>"+
              "<div style='display:flex;margin-left:12px'>" +
              "<span style='font-size:12px;color:#898B8D;'>Transfer Amount : </span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              dataaa[indexs] +
              "</span>" +
              "</div>";
            return str;
          },
        },
        grid: {
          top: "19%",
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [820, 932, 901, 934, 1290, 1330, 1320],
          },
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#D3F85A",
                },
                {
                  offset: 0,
                  color: "#D3F85A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#D3F85A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [82, 92, 91, 34, 190, 130, 120],
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    initChartsa() {
      this.lineChart = echarts.init(this.$refs.charts);
      let option = {
          tooltip: {
          trigger: "axis",
          backgroundColor: "#242931", //设置背景图片 rgba格式
          color: "rgba(255, 255, 255, 0.5)",
          formatter: function (params) {
            let str =
              '<span style="color:#898B8D;font-size:12px;">' +
              params[0].name +
              "(UTC)" +
              "</span>" +
              "</br>" +
              
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#00E79A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>Transactions:</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              params[0].value +
              "</span>" +
              "</div>" +
              "<div style='display:flex'>" +
              "<span style='margin-top:8px;margin-right:6px;width:6px;height:6px;border-radius:50%;background:#D3F85A;display:block'></span>" +
              "<span style='font-size:12px;color:#898B8D;'>Total TTOS Staked:</span>" +
              '<span style="color:#fff;font-size:12px;margin-left:2px;">' +
              params[1].value +
              "</span>" +
              "</div>";
            return str;
          },
        },
        // legend: {
        //   data: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
        // },
        grid: {
          top: "19%",
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true,
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //   },
        // },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [820, 932, 901, 934, 1290, 1330, 1320],
          },
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#D3F85A",
                },
                {
                  offset: 0,
                  color: "#D3F85A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#D3F85A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [82, 92, 91, 34, 190, 130, 120],
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    CurrentChange(val) {
      this.PaginationIndex = val;
      this.setContextData("tiaozhuan1", this.PaginationIndex);
      this.blockList();
    },
    async blockList() {
      this.Page1 = this.getContextData("tiaozhuan1") || 1;
      const params = {
        pageNum: this.PaginationIndex,
        pageSize: 10,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      await BlockList(formData).then((res) => {
        this.list = res.result.tradeList;
        this.total1 = res.result.total;
        this.index = 1;
        var calctime = new Date();
        let strdate = Math.floor(calctime.getTime() / 1000);
        for (let i = 0; i < this.list.length; i++) {
          let UTCTime =
            res.result.tradeList[i].tradeTime -
            this.getClientTimezone * 3600000;
          this.TimeDate[i] = timestampConvertTime(UTCTime);
          let timestamp = Math.floor(
            this.gltime(this.list[i].tradeTime) / 1000
          );

          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          this.list[i].tradeTime = formatSeconds(s);
        }
      });
    },
    Block(index) {
      this.$router.push({
        path: "/pc/BkHeight",
        query: { height: index },
      });
    },
    Hash(index) {
      this.$router.push({ path: "/pc/BkDetail", query: { blockHash: index } });
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
    setContextData: function (key, value) {
      if (typeof value == "string") {
        sessionStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
    },
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
  },
};
</script>

<style lang="less" scoped>
.Tranbox_right {
  width: 1160px;
  height: 936px;
  // background: #000000;
  margin: 0 auto;
  opacity: 1;
  .chartsall {
    display: flex;
    justify-content: space-between;
    .chartstit {
      padding-top: 20px;
      margin-left: 20px;
      height: 26px;
      font-size: 18px;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #ffffff;
      line-height: 26px;
    }
    .Hombox_sr {
      position: relative;
      .hombottn {
        z-index: 99;
        display: flex;
        width: 48px;
        height: 25px;
        background: #242931;
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        margin-top: 20px;
        margin-right: 20px;
        div {
          height: 17px;
          font-size: 12px;
          font-family: Source Han Sans CN-Regular, Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
          line-height: 17px;
          margin-top: 4px;
          margin-left: 7px;
        }
        img {
          width: 16px;
          height: 15px;
          margin-top: 5px;
          margin-left: 2px;
        }
      }
      .headcontent {
        width: 48px;
        height: 108px;
        background: #15171a;
        border-radius: 6px 6px 6px 6px;
        opacity: 1;
        position: absolute;
        left: 0px;
        top: 50px;
        z-index: 88;
        ul {
          // margin: 12px;
          margin-left: 12px;
          li:nth-child(1) {
            margin-top: 5px;
          }
          li {
            height: 21px;
            line-height: 21px;
            cursor: pointer;
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #8e9093;
          }
          .active {
            cursor: pointer;
            color: #00a870;
          }
        }
      }
    }
  }
  .charts {
    margin-top: 20px;
    width: 1120px;
    height: 401px;
    background: #0b0c0f;
    border-radius: 10px 10px 10px 10px;
    opacity: 1;
  }
}
</style>
